import { SVGProps } from '@components/Icon/types';

export const FileWord = ({ fill = '#000', size = 24, ...props }: SVGProps) => (
  <svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <g transform="translate(4, 2)">
      <path
        d="M11.6192 8.01758C11.9319 8.09422 12.1224 8.40399 12.0444 8.70996L10.2917 15.5674C10.2272 15.8193 9.99721 15.9971 9.73175 16C9.46615 16.0028 9.23179 15.8298 9.16182 15.5791L7.97305 11.3145L6.78428 15.5791C6.7143 15.8298 6.47994 16.0028 6.21435 16C5.94894 15.997 5.71887 15.8193 5.6544 15.5674L3.90268 8.70996C3.82454 8.40396 4.01424 8.09429 4.32689 8.01758C4.63971 7.94106 4.95719 8.12664 5.03556 8.43262L6.24529 13.1689L7.41011 8.99219C7.47957 8.74388 7.70989 8.57132 7.97305 8.57129C8.23632 8.57129 8.46759 8.74375 8.53699 8.99219L9.70081 13.1689L10.9105 8.43262C10.9889 8.12662 11.3064 7.94106 11.6192 8.01758Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.36145 0C9.91163 3.30681e-05 10.4397 0.213647 10.8287 0.594727L15.8253 5.4834C15.9084 5.56477 15.9651 5.66846 15.988 5.78125C15.9921 5.80144 15.9981 5.89877 16 5.91895L15.999 17.4863C15.9989 18.8689 14.8429 20 13.4298 20H2.57018C1.15709 20 0.000119203 18.8689 0 17.4863V2.51367C0.000118986 1.13114 1.15709 0 2.57018 0H9.36145ZM2.57018 1.16406C1.80251 1.16406 1.18989 1.76262 1.18977 2.51367V17.4863C1.18989 18.2374 1.80251 18.8359 2.57018 18.8359H13.4298C14.1975 18.8359 14.8091 18.2374 14.8092 17.4863V8.21777L14.8052 6.47656H11.4555C10.8493 6.47656 10.301 6.21831 9.9204 5.80859C9.58501 5.44744 9.37941 4.96805 9.37941 4.44531V1.17773L9.37143 1.17285L9.36843 1.1709C9.36197 1.16702 9.35763 1.16516 9.35546 1.16406H2.57018ZM10.5692 4.44531C10.5692 4.92995 10.9602 5.3125 11.4555 5.3125H13.9688L10.5692 1.9873V4.44531ZM0.101809 2.5498V2.54785L0 2.51367L0.101809 2.5498Z"
        fill={fill}
      />
    </g>
  </svg>
);

export const ICON_NAME = 'file-word';
